const jhsrmeQuestions = [
  
{
  question: "Which of the following statements about God is accepted in Christianity, Islam and African Traditional Religion?",
  options: [
    "God is limited in power",
    "God depends on humans",
    "God is perfect and all-powerful",
    "God exists only in specific places"
  ],
  answer: "God is perfect and all-powerful"
},
{
  question: "A student forgives a friend who offended him. Which attribute of God is he demonstrating?",
  options: [
    "Justice",
    "Mercy",
    "Power",
    "Omnipresence"
  ],
  answer: "Mercy"
},
{
  question: "Which of the following actions contradicts the nature of God?",
  options: [
    "Showing patience",
    "Speaking the truth",
    "Practising kindness",
    "Telling lies"
  ],
  answer: "Telling lies"
},
{
  question: "Which of the following best explains worship?",
  options: [
    "Performing rituals for entertainment",
    "Submission and devotion to God",
    "Gathering for social interaction",
    "Reading books in public places"
  ],
  answer: "Submission and devotion to God"
},
{
  question: "Which of the following is a distinguishing feature of congregational worship?",
  options: [
    "Done in silence",
    "Performed by individuals alone",
    "Involves a group gathering together",
    "Practised only during festivals"
  ],
  answer: "Involves a group gathering together"
},
{
  question: "Which of the following is common to worship in all three major religions?",
  options: [
    "Use of musical instruments only",
    "Communication with the Creator",
    "Animal sacrifice in all cases",
    "Reading the Bible only"
  ],
  answer: "Communication with the Creator"
},
{
  question: "Why is prayer important in religion?",
  options: [
    "It entertains believers",
    "It replaces work",
    "It builds a relationship with the Creator",
    "It shows superiority over others"
  ],
  answer: "It builds a relationship with the Creator"
},
{
  question: "Which Islamic practice emphasizes purification before prayer?",
  options: [
    "Zakat",
    "Ablution",
    "Hajj",
    "Sadaqah"
  ],
  answer: "Ablution"
},
{
  question: "Which of the following best describes private worship?",
  options: [
    "Worship during festivals",
    "Worship done individually or within a family",
    "Worship done only in public places",
    "Worship led by religious leaders"
  ],
  answer: "Worship done individually or within a family"
},
{
  question: "Which of the following best defines a family?",
  options: [
    "People living in the same town",
    "A group bound by blood, marriage or adoption",
    "A gathering of friends",
    "People who attend the same school"
  ],
  answer: "A group bound by blood, marriage or adoption"
},
{
  question: "Which of the following distinguishes an extended family from a nuclear family?",
  options: [
    "Presence of children only",
    "Inclusion of relatives beyond parents and children",
    "Living in one building",
    "Sharing the same occupation"
  ],
  answer: "Inclusion of relatives beyond parents and children"
},
{
  question: "Which of the following is a major advantage of the nuclear family system?",
  options: [
    "Increased interference",
    "Easy supervision of children",
    "Lack of privacy",
    "Financial burden from many dependents"
  ],
  answer: "Easy supervision of children"
},
{
  question: "Which of the following is a major challenge of the extended family system?",
  options: [
    "Lack of support",
    "Isolation",
    "Loss of privacy",
    "Weak social bonds"
  ],
  answer: "Loss of privacy"
},
{
  question: "According to religious teachings, what is a major duty of children?",
  options: [
    "Controlling family decisions",
    "Honouring and obeying parents",
    "Avoiding responsibilities",
    "Seeking independence at all times"
  ],
  answer: "Honouring and obeying parents"
},
{
  question: "Which of the following best promotes peaceful family relationships?",
  options: [
    "False accusations",
    "Patience and forgiveness",
    "Ignoring problems",
    "Frequent arguments"
  ],
  answer: "Patience and forgiveness"
},
{
  question: "Which of the following best describes good manners?",
  options: [
    "Acting to impress others",
    "Behaviour accepted by society",
    "Following friends blindly",
    "Speaking loudly in public"
  ],
  answer: "Behaviour accepted by society"
},
{
  question: "Which of the following behaviours demonstrates courtesy?",
  options: [
    "Interrupting elders",
    "Greeting politely",
    "Ignoring instructions",
    "Speaking harshly"
  ],
  answer: "Greeting politely"
},
{
  question: "Which of the following best explains chastity?",
  options: [
    "Freedom to do anything",
    "Avoidance of immoral sexual behaviour",
    "Engaging in relationships early",
    "Ignoring moral teachings"
  ],
  answer: "Avoidance of immoral sexual behaviour"
},
{
  question: "Which of the following is a benefit of practising chastity?",
  options: [
    "Encourages early marriage",
    "Promotes moral discipline",
    "Leads to social rejection",
    "Encourages peer pressure"
  ],
  answer: "Promotes moral discipline"
},
{
  question: "Which of the following best explains the attribute of omnipresence?",
  options: [
    "God knows everything",
    "God is present everywhere at all times",
    "God has unlimited power",
    "God punishes all sinners"
  ],
  answer: "God is present everywhere at all times"
},
{
  question: "Which of the following actions shows belief in God's omnipotence?",
  options: [
    "Doubting God's ability",
    "Trusting that God can do all things",
    "Ignoring religious teachings",
    "Depending only on humans"
  ],
  answer: "Trusting that God can do all things"
},
{
  question: "Why should humans take care of the environment according to religious teachings?",
  options: [
    "To gain wealth only",
    "Because they are stewards of God's creation",
    "To impress others",
    "Because it is a government duty only"
  ],
  answer: "Because they are stewards of God's creation"
},
{
  question: "Which of the following best describes stewardship?",
  options: [
    "Ownership of all resources",
    "Careful management of what God has given",
    "Destruction of resources",
    "Using resources without limits"
  ],
  answer: "Careful management of what God has given"
},
{
  question: "Which of the following is an example of misuse of the environment?",
  options: [
    "Planting trees",
    "Recycling waste",
    "Illegal mining",
    "Cleaning surroundings"
  ],
  answer: "Illegal mining"
},
{
  question: "Which of the following best defines obedience?",
  options: [
    "Doing whatever one likes",
    "Following instructions willingly",
    "Ignoring authority",
    "Avoiding responsibility"
  ],
  answer: "Following instructions willingly"
},
{
  question: "Which of the following is a religious reason for obeying parents?",
  options: [
    "To gain wealth",
    "To receive blessings",
    "To avoid punishment only",
    "To control the family"
  ],
  answer: "To receive blessings"
},
{
  question: "A child refuses to follow instructions from parents. Which value is lacking?",
  options: [
    "Obedience",
    "Patience",
    "Respect",
    "Faith"
  ],
  answer: "Obedience"
},
{
  question: "Which of the following best explains disobedience?",
  options: [
    "Following rules carefully",
    "Refusal to follow instructions",
    "Showing respect",
    "Helping others"
  ],
  answer: "Refusal to follow instructions"
},
{
  question: "Which of the following is a consequence of disobedience in the family?",
  options: [
    "Peace",
    "Harmony",
    "Conflict",
    "Unity"
  ],
  answer: "Conflict"
},
{
  question: "Which of the following is a type of prayer?",
  options: [
    "Entertainment",
    "Thanksgiving",
    "Punishment",
    "Competition"
  ],
  answer: "Thanksgiving"
},
{
  question: "Which of the following prayers is said to ask for forgiveness?",
  options: [
    "Adoration",
    "Confession",
    "Thanksgiving",
    "Intercession"
  ],
  answer: "Confession"
},
{
  question: "Which of the following involves praying for others?",
  options: [
    "Supplication",
    "Intercession",
    "Confession",
    "Adoration"
  ],
  answer: "Intercession"
},
{
  question: "Which of the following best explains adoration?",
  options: [
    "Asking for help",
    "Praising and worshipping God",
    "Confessing sins",
    "Praying for others"
  ],
  answer: "Praising and worshipping God"
},
{
  question: "Which of the following is common in Islamic prayer?",
  options: [
    "Clapping hands",
    "Facing Mecca",
    "Dancing",
    "Playing instruments"
  ],
  answer: "Facing Mecca"
},
{
  question: "Which of the following is a feature of Christian worship?",
  options: [
    "Reciting the Quran",
    "Reading the Bible",
    "Facing Mecca",
    "Animal sacrifice only"
  ],
  answer: "Reading the Bible"
},
{
  question: "Which of the following is associated with African Traditional Religion worship?",
  options: [
    "Mosque",
    "Church",
    "Shrine",
    "Cathedral"
  ],
  answer: "Shrine"
},
{
  question: "Which of the following is a sign of respect in Ghanaian culture?",
  options: [
    "Ignoring elders",
    "Greeting properly",
    "Shouting in public",
    "Interrupting conversations"
  ],
  answer: "Greeting properly"
},
{
  question: "Which of the following best explains modest dressing?",
  options: [
    "Wearing expensive clothes",
    "Dressing decently to show respect",
    "Following fashion blindly",
    "Wearing any clothes"
  ],
  answer: "Dressing decently to show respect"
},
{
  question: "Which of the following behaviour reflects good character?",
  options: [
    "Dishonesty",
    "Respect",
    "Violence",
    "Disobedience"
  ],
  answer: "Respect"
},
{
  question: "Which of the following best explains the concept of work in religious teachings?",
  options: [
    "Avoiding effort",
    "Using one's ability to earn a living",
    "Relying on others",
    "Engaging in leisure activities only"
  ],
  answer: "Using one's ability to earn a living"
},
{
  question: "Why is hard work encouraged in religion?",
  options: [
    "To show pride",
    "To become independent and responsible",
    "To avoid helping others",
    "To gain power over others"
  ],
  answer: "To become independent and responsible"
},
{
  question: "Which of the following best describes laziness?",
  options: [
    "Working hard daily",
    "Avoiding duties and responsibilities",
    "Helping others",
    "Managing time well"
  ],
  answer: "Avoiding duties and responsibilities"
},
{
  question: "Which of the following is a consequence of laziness?",
  options: [
    "Success",
    "Progress",
    "Poverty",
    "Achievement"
  ],
  answer: "Poverty"
},
{
  question: "Which of the following best explains time management?",
  options: [
    "Wasting time",
    "Planning and using time effectively",
    "Ignoring schedules",
    "Avoiding responsibilities"
  ],
  answer: "Planning and using time effectively"
},
{
  question: "A student studies regularly and completes assignments on time. Which value is demonstrated?",
  options: [
    "Laziness",
    "Time management",
    "Negligence",
    "Carelessness"
  ],
  answer: "Time management"
},
{
  question: "Which of the following best explains misuse of money?",
  options: [
    "Saving regularly",
    "Spending on unnecessary things",
    "Budgeting carefully",
    "Investing wisely"
  ],
  answer: "Spending on unnecessary things"
},
{
  question: "Which of the following is a good way to manage money?",
  options: [
    "Spending everything at once",
    "Saving and budgeting",
    "Borrowing unnecessarily",
    "Ignoring needs"
  ],
  answer: "Saving and budgeting"
},
{
  question: "Which of the following is a moral lesson from religious teachings on money?",
  options: [
    "Be greedy",
    "Use money wisely",
    "Avoid helping others",
    "Spend without thinking"
  ],
  answer: "Use money wisely"
},
{
  question: "Which of the following best explains honesty?",
  options: [
    "Telling lies",
    "Speaking the truth at all times",
    "Hiding information",
    "Deceiving others"
  ],
  answer: "Speaking the truth at all times"
},
{
  question: "Which of the following religious personalities is known as the founder of Islam?",
  options: [
    "Jesus Christ",
    "Prophet Muhammad",
    "Abraham",
    "Moses"
  ],
  answer: "Prophet Muhammad"
},
{
  question: "Which of the following religious personalities is central to Christianity?",
  options: [
    "Moses",
    "Jesus Christ",
    "Muhammad",
    "David"
  ],
  answer: "Jesus Christ"
},
{
  question: "Which of the following best explains a prophet?",
  options: [
    "A political leader",
    "A messenger of God",
    "A wealthy person",
    "A teacher only"
  ],
  answer: "A messenger of God"
},
{
  question: "Which of the following is a role of prophets?",
  options: [
    "Encouraging wrongdoing",
    "Guiding people to follow God's will",
    "Promoting conflict",
    "Avoiding responsibilities"
  ],
  answer: "Guiding people to follow God's will"
},
{
  question: "Which of the following best explains a festival?",
  options: [
    "A time for conflict",
    "A special celebration with religious or cultural significance",
    "A time for punishment",
    "A normal working day"
  ],
  answer: "A special celebration with religious or cultural significance"
},
{
  question: "Which of the following is a Christian festival?",
  options: [
    "Eid-ul-Fitr",
    "Christmas",
    "Odwira",
    "Hajj"
  ],
  answer: "Christmas"
},
{
  question: "Which of the following is an Islamic festival?",
  options: [
    "Easter",
    "Eid-ul-Adha",
    "Homowo",
    "Pentecost"
  ],
  answer: "Eid-ul-Adha"
},
{
  question: "Which of the following is a traditional Ghanaian festival?",
  options: [
    "Christmas",
    "Eid-ul-Fitr",
    "Odwira",
    "Lent"
  ],
  answer: "Odwira"
},
{
  question: "Which of the following is a purpose of festivals?",
  options: [
    "To create conflict",
    "To remember important events",
    "To waste time",
    "To avoid work"
  ],
  answer: "To remember important events"
},
{
  question: "A student refuses to steal even when given the opportunity. Which value is demonstrated?",
  options: [
    "Dishonesty",
    "Integrity",
    "Greed",
    "Fear"
  ],
  answer: "Integrity"
},
{
  question: "A student claims God is only present in places of worship. Which attribute of God is being misunderstood?",
  options: [
    "Omnipotence",
    "Omniscience",
    "Omnipresence",
    "Mercy"
  ],
  answer: "Omnipresence"
},
{
  question: "A person refuses to help others despite having enough resources. Which teaching of stewardship is being violated?",
  options: [
    "Ownership",
    "Accountability",
    "Selfishness",
    "Isolation"
  ],
  answer: "Accountability"
},
{
  question: "Which of the following situations best demonstrates true obedience?",
  options: [
    "Following instructions only when supervised",
    "Obeying rules willingly even when alone",
    "Ignoring rules when convenient",
    "Questioning authority always"
  ],
  answer: "Obeying rules willingly even when alone"
},
{
  question: "A child obeys parents only to avoid punishment. Which type of obedience is this?",
  options: [
    "Voluntary obedience",
    "Religious obedience",
    "Forced obedience",
    "Moral obedience"
  ],
  answer: "Forced obedience"
},
{
  question: "Which of the following best explains why disobedience leads to conflict in families?",
  options: [
    "It promotes unity",
    "It breaks trust and respect",
    "It encourages communication",
    "It strengthens relationships"
  ],
  answer: "It breaks trust and respect"
},
{
  question: "A believer prays regularly but treats others badly. What does this suggest?",
  options: [
    "True worship",
    "Balanced religious life",
    "Lack of practical application of faith",
    "Strong moral character"
  ],
  answer: "Lack of practical application of faith"
},
{
  question: "Which of the following best distinguishes worship from prayer?",
  options: [
    "Worship involves only singing",
    "Prayer is communication, worship includes total devotion",
    "Prayer is done in groups only",
    "Worship is done silently"
  ],
  answer: "Prayer is communication, worship includes total devotion"
},
{
  question: "A student wastes time daily and fails exams. Which moral lesson applies?",
  options: [
    "Time is unlimited",
    "Time should be managed wisely",
    "Failure is unavoidable",
    "Luck determines success"
  ],
  answer: "Time should be managed wisely"
},
{
  question: "Which of the following best explains why laziness is discouraged in religion?",
  options: [
    "It promotes success",
    "It leads to dependency and poverty",
    "It improves health",
    "It increases productivity"
  ],
  answer: "It leads to dependency and poverty"
},
{
  question: "A person spends money on luxury items while neglecting basic needs. What is this an example of?",
  options: [
    "Budgeting",
    "Saving",
    "Mismanagement of resources",
    "Investment"
  ],
  answer: "Mismanagement of resources"
},
{
  question: "Which of the following best explains integrity?",
  options: [
    "Doing what is right only when observed",
    "Being consistent in doing what is right",
    "Avoiding responsibility",
    "Following others blindly"
  ],
  answer: "Being consistent in doing what is right"
},
{
  question: "A student copies during exams and later feels guilty. Which moral lesson applies?",
  options: [
    "Dishonesty has no consequences",
    "Wrong actions affect conscience",
    "Cheating guarantees success",
    "Rules are unnecessary"
  ],
  answer: "Wrong actions affect conscience"
},
{
  question: "Which of the following best explains the role of prophets in society?",
  options: [
    "They control governments",
    "They guide people spiritually and morally",
    "They focus on wealth creation",
    "They avoid societal issues"
  ],
  answer: "They guide people spiritually and morally"
},
{
  question: "Which of the following best explains why festivals are important in religion?",
  options: [
    "They encourage laziness",
    "They remind believers of important events and values",
    "They promote conflict",
    "They reduce unity"
  ],
  answer: "They remind believers of important events and values"
},
{
  question: "A person attends religious festivals but behaves immorally afterward. What does this indicate?",
  options: [
    "Strong faith",
    "Consistency",
    "Hypocrisy",
    "Commitment"
  ],
  answer: "Hypocrisy"
},
{
  question: "Which of the following best explains chastity in modern society?",
  options: [
    "Avoiding all relationships",
    "Practising self-control in sexual behaviour",
    "Ignoring moral teachings",
    "Following peer pressure"
  ],
  answer: "Practising self-control in sexual behaviour"
},
{
  question: "Which of the following is a major consequence of immoral behaviour among the youth?",
  options: [
    "Respect",
    "Stability",
    "Social problems",
    "Discipline"
  ],
  answer: "Social problems"
},
{
  question: "A teenager refuses to join friends in taking drugs. Which value is demonstrated?",
  options: [
    "Weakness",
    "Self-control",
    "Fear",
    "Isolation"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains substance abuse?",
  options: [
    "Proper use of medicine",
    "Misuse of drugs and harmful substances",
    "Taking prescribed drugs",
    "Eating healthy food"
  ],
  answer: "Misuse of drugs and harmful substances"
},
{
  question: "Which of the following is the most effective way to prevent substance abuse?",
  options: [
    "Ignoring the problem",
    "Education and self-discipline",
    "Punishment only",
    "Isolation from society"
  ],
  answer: "Education and self-discipline"
},
{
  question: "Which of the following best explains a rite of passage?",
  options: [
    "Daily activities",
    "A ceremony marking a stage in life",
    "A religious law",
    "A cultural punishment"
  ],
  answer: "A ceremony marking a stage in life"
},
{
  question: "Which of the following is an example of a rite of passage?",
  options: [
    "Eating food",
    "Naming ceremony",
    "Playing games",
    "Watching television"
  ],
  answer: "Naming ceremony"
},
{
  question: "Which stage of life is associated with puberty rites?",
  options: [
    "Infancy",
    "Childhood",
    "Adolescence",
    "Old age"
  ],
  answer: "Adolescence"
},
{
  question: "Which of the following is the main purpose of puberty rites?",
  options: [
    "To entertain society",
    "To prepare individuals for adulthood",
    "To punish children",
    "To promote wealth"
  ],
  answer: "To prepare individuals for adulthood"
},
{
  question: "Which of the following best explains marriage in religion?",
  options: [
    "A temporary relationship",
    "A lifelong union between partners",
    "A social gathering",
    "A financial agreement only"
  ],
  answer: "A lifelong union between partners"
},
{
  question: "Which of the following is a responsibility of married couples?",
  options: [
    "Neglecting family",
    "Supporting each other",
    "Avoiding communication",
    "Ignoring children"
  ],
  answer: "Supporting each other"
},
{
  question: "Which of the following best explains death rites?",
  options: [
    "Celebrations only",
    "Ceremonies to honour the dead",
    "Entertainment events",
    "Economic activities"
  ],
  answer: "Ceremonies to honour the dead"
},
{
  question: "Why are death rites important in society?",
  options: [
    "To create fear",
    "To show respect for the deceased",
    "To waste resources",
    "To promote conflict"
  ],
  answer: "To show respect for the deceased"
},
{
  question: "Which of the following best explains moral decision-making?",
  options: [
    "Following friends always",
    "Choosing between right and wrong",
    "Ignoring consequences",
    "Acting without thinking"
  ],
  answer: "Choosing between right and wrong"
},
{
  question: "A student chooses honesty over cheating despite pressure. What is demonstrated?",
  options: [
    "Weakness",
    "Integrity",
    "Fear",
    "Carelessness"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains peer pressure?",
  options: [
    "Influence from elders",
    "Influence from friends of the same age",
    "Government influence",
    "Religious teachings"
  ],
  answer: "Influence from friends of the same age"
},
{
  question: "Which of the following is a negative effect of peer pressure?",
  options: [
    "Good behaviour",
    "Academic success",
    "Involvement in bad habits",
    "Self-discipline"
  ],
  answer: "Involvement in bad habits"
},
{
  question: "Which of the following best explains self-control?",
  options: [
    "Doing whatever one likes",
    "Ability to control one's behaviour",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Ability to control one's behaviour"
},
{
  question: "A student refuses to engage in immoral behaviour. Which value is shown?",
  options: [
    "Weakness",
    "Chastity",
    "Fear",
    "Isolation"
  ],
  answer: "Chastity"
},
{
  question: "Which of the following is a cause of immoral behaviour among the youth?",
  options: [
    "Good parenting",
    "Peer pressure",
    "Religious teachings",
    "Self-discipline"
  ],
  answer: "Peer pressure"
},
{
  question: "Which of the following is a way to promote moral behaviour?",
  options: [
    "Ignoring rules",
    "Proper upbringing",
    "Following bad friends",
    "Avoiding guidance"
  ],
  answer: "Proper upbringing"
},
{
  question: "Which of the following best explains reward in religion?",
  options: [
    "Punishment for wrongdoing",
    "Blessings for good behaviour",
    "Ignoring actions",
    "Avoiding responsibilities"
  ],
  answer: "Blessings for good behaviour"
},
{
  question: "Which of the following best explains punishment in religion?",
  options: [
    "Reward for good actions",
    "Consequences of wrongdoing",
    "Ignoring behaviour",
    "Avoiding discipline"
  ],
  answer: "Consequences of wrongdoing"
},
{
  question: "Which of the following best explains repentance?",
  options: [
    "Continuing wrongdoing",
    "Feeling sorry and changing behaviour",
    "Ignoring mistakes",
    "Blaming others"
  ],
  answer: "Feeling sorry and changing behaviour"
},
{
  question: "A person corrects wrong actions and avoids repeating them. What is demonstrated?",
  options: [
    "Punishment",
    "Repentance",
    "Disobedience",
    "Negligence"
  ],
  answer: "Repentance"
},
{
  question: "Which of the following best explains a religious organization?",
  options: [
    "A group for entertainment",
    "A group formed to promote religious activities and values",
    "A business group",
    "A political party"
  ],
  answer: "A group formed to promote religious activities and values"
},
{
  question: "Which of the following is an example of a religious youth organization?",
  options: [
    "Debate club",
    "Scripture Union",
    "Football team",
    "Science club"
  ],
  answer: "Scripture Union"
},
{
  question: "Which of the following is a benefit of joining a religious youth organization?",
  options: [
    "Encourages bad behaviour",
    "Promotes spiritual growth",
    "Leads to indiscipline",
    "Discourages learning"
  ],
  answer: "Promotes spiritual growth"
},
{
  question: "Which of the following best explains tolerance in religion?",
  options: [
    "Forcing others to change beliefs",
    "Respecting different religious beliefs",
    "Ignoring other religions",
    "Rejecting all beliefs"
  ],
  answer: "Respecting different religious beliefs"
},
{
  question: "Which of the following is an effect of religious intolerance?",
  options: [
    "Peace",
    "Unity",
    "Conflict",
    "Cooperation"
  ],
  answer: "Conflict"
},
{
  question: "Which of the following best explains unity?",
  options: [
    "Division among people",
    "Working together peacefully",
    "Avoiding interaction",
    "Promoting conflict"
  ],
  answer: "Working together peacefully"
},
{
  question: "Which of the following best explains forgiveness?",
  options: [
    "Seeking revenge",
    "Letting go of anger towards others",
    "Ignoring wrongdoing",
    "Punishing others"
  ],
  answer: "Letting go of anger towards others"
},
{
  question: "Which of the following is a benefit of forgiveness?",
  options: [
    "Creates conflict",
    "Promotes peace",
    "Encourages hatred",
    "Leads to revenge"
  ],
  answer: "Promotes peace"
},
{
  question: "A student refuses to forgive a friend and plans revenge. Which value is lacking?",
  options: [
    "Patience",
    "Forgiveness",
    "Respect",
    "Obedience"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains humility?",
  options: [
    "Pride and arrogance",
    "Recognizing one's limitations and being modest",
    "Showing superiority",
    "Ignoring others"
  ],
  answer: "Recognizing one's limitations and being modest"
},
{
  question: "Which of the following behaviour shows humility?",
  options: [
    "Boasting about achievements",
    "Listening to others respectfully",
    "Ignoring advice",
    "Looking down on others"
  ],
  answer: "Listening to others respectfully"
},
{
  question: "Which of the following best explains kindness?",
  options: [
    "Harming others",
    "Helping others willingly",
    "Ignoring needs",
    "Avoiding people"
  ],
  answer: "Helping others willingly"
},
{
  question: "Which of the following is a result of kindness?",
  options: [
    "Hatred",
    "Conflict",
    "Good relationships",
    "Isolation"
  ],
  answer: "Good relationships"
},
{
  question: "Which of the following best explains greed?",
  options: [
    "Contentment",
    "Desire for more than one needs",
    "Sharing with others",
    "Helping people"
  ],
  answer: "Desire for more than one needs"
},
{
  question: "Which of the following is a negative effect of greed?",
  options: [
    "Unity",
    "Honesty",
    "Conflict",
    "Peace"
  ],
  answer: "Conflict"
},
{
  question: "Which of the following best explains contentment?",
  options: [
    "Being satisfied with what one has",
    "Always wanting more",
    "Comparing with others",
    "Ignoring needs"
  ],
  answer: "Being satisfied with what one has"
},
{
  question: "Which of the following is a benefit of contentment?",
  options: [
    "Jealousy",
    "Peace of mind",
    "Conflict",
    "Greed"
  ],
  answer: "Peace of mind"
},
{
  question: "A student always compares himself to others and feels unhappy. Which value is lacking?",
  options: [
    "Contentment",
    "Patience",
    "Obedience",
    "Kindness"
  ],
  answer: "Contentment"
},
{
  question: "Which of the following best explains patience?",
  options: [
    "Acting quickly without thinking",
    "Waiting calmly without anger",
    "Avoiding responsibility",
    "Ignoring others"
  ],
  answer: "Waiting calmly without anger"
},
{
  question: "Which of the following is a benefit of patience?",
  options: [
    "Leads to conflict",
    "Promotes wise decisions",
    "Encourages mistakes",
    "Creates confusion"
  ],
  answer: "Promotes wise decisions"
},
{
  question: "A student says God only helps those who pray loudly in public. Which understanding is incorrect?",
  options: [
    "God hears all prayers",
    "God values sincerity over show",
    "God responds only to public prayers",
    "God is aware of all actions"
  ],
  answer: "God responds only to public prayers"
},
{
  question: "A person gives to the poor but expects praise from others. What does this suggest?",
  options: [
    "True generosity",
    "Selflessness",
    "Pride",
    "Humility"
  ],
  answer: "Pride"
},
{
  question: "Which of the following best explains why stewardship requires accountability?",
  options: [
    "Resources belong to individuals permanently",
    "Humans must answer for how they use God's creation",
    "People can use resources freely without limits",
    "Only leaders manage resources"
  ],
  answer: "Humans must answer for how they use God's creation"
},
{
  question: "A child obeys parents only when others are watching. What type of behaviour is this?",
  options: [
    "Genuine obedience",
    "Pretence",
    "Commitment",
    "Faithfulness"
  ],
  answer: "Pretence"
},
{
  question: "Which of the following best explains the relationship between worship and behaviour?",
  options: [
    "Worship replaces good behaviour",
    "Worship should reflect in daily conduct",
    "Behaviour is not important in religion",
    "Worship is only for ceremonies"
  ],
  answer: "Worship should reflect in daily conduct"
},
{
  question: "A student cheats in exams but attends church regularly. What is the best conclusion?",
  options: [
    "He is religious",
    "He understands religion fully",
    "He lacks integrity",
    "He is disciplined"
  ],
  answer: "He lacks integrity"
},
{
  question: "Which of the following best explains why time is considered a valuable resource?",
  options: [
    "It can be recovered when lost",
    "It is unlimited",
    "It cannot be replaced once wasted",
    "It is not important"
  ],
  answer: "It cannot be replaced once wasted"
},
{
  question: "A person delays important tasks repeatedly. Which value is lacking?",
  options: [
    "Time consciousness",
    "Faith",
    "Worship",
    "Kindness"
  ],
  answer: "Time consciousness"
},
{
  question: "Which of the following best explains the danger of greed?",
  options: [
    "It promotes sharing",
    "It leads to selfishness and conflict",
    "It encourages contentment",
    "It builds relationships"
  ],
  answer: "It leads to selfishness and conflict"
},
{
  question: "A student refuses to share with others despite having enough. Which value is lacking?",
  options: [
    "Kindness",
    "Patience",
    "Obedience",
    "Faith"
  ],
  answer: "Kindness"
},
{
  question: "Which of the following best explains why forgiveness is difficult?",
  options: [
    "It requires strength and humility",
    "It is unnecessary",
    "It encourages revenge",
    "It promotes conflict"
  ],
  answer: "It requires strength and humility"
},
{
  question: "A person forgives but keeps reminding others of their mistakes. What does this indicate?",
  options: [
    "True forgiveness",
    "Incomplete forgiveness",
    "Humility",
    "Patience"
  ],
  answer: "Incomplete forgiveness"
},
{
  question: "Which of the following best explains moral responsibility?",
  options: [
    "Following others blindly",
    "Being accountable for one's actions",
    "Ignoring consequences",
    "Avoiding decisions"
  ],
  answer: "Being accountable for one's actions"
},
{
  question: "A student blames others for his mistakes. Which value is lacking?",
  options: [
    "Responsibility",
    "Patience",
    "Kindness",
    "Tolerance"
  ],
  answer: "Responsibility"
},
{
  question: "Which of the following best explains tolerance in a multi-religious society?",
  options: [
    "Rejecting other beliefs",
    "Respecting and accepting differences",
    "Avoiding interaction",
    "Promoting one religion only"
  ],
  answer: "Respecting and accepting differences"
},
{
  question: "A conflict arises because people refuse to accept different beliefs. What is lacking?",
  options: [
    "Tolerance",
    "Faith",
    "Worship",
    "Obedience"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following best explains why substance abuse is morally wrong?",
  options: [
    "It improves health",
    "It destroys self-control and judgment",
    "It increases productivity",
    "It promotes discipline"
  ],
  answer: "It destroys self-control and judgment"
},
{
  question: "A student begins taking harmful substances due to peer pressure. What is the root cause?",
  options: [
    "Self-control",
    "Strong character",
    "Weak decision-making",
    "Religious commitment"
  ],
  answer: "Weak decision-making"
},
{
  question: "Which of the following best explains repentance?",
  options: [
    "Admitting wrong without change",
    "Feeling sorry and making positive change",
    "Ignoring mistakes",
    "Blaming others"
  ],
  answer: "Feeling sorry and making positive change"
},
{
  question: "A person repeats the same wrong actions after apologizing. What does this show?",
  options: [
    "True repentance",
    "Lack of change",
    "Humility",
    "Obedience"
  ],
  answer: "Lack of change"
},
{
  question: "Which of the following best explains why God is described as just?",
  options: [
    "He ignores wrongdoing",
    "He rewards good and punishes evil",
    "He treats people unequally",
    "He depends on humans"
  ],
  answer: "He rewards good and punishes evil"
},
{
  question: "A person believes wrongdoing will never be punished. Which religious teaching is being ignored?",
  options: [
    "Mercy",
    "Justice",
    "Love",
    "Faith"
  ],
  answer: "Justice"
},
{
  question: "Which of the following best explains the importance of moral laws?",
  options: [
    "They restrict freedom unnecessarily",
    "They guide behaviour towards good living",
    "They create confusion",
    "They encourage wrongdoing"
  ],
  answer: "They guide behaviour towards good living"
},
{
  question: "A student follows rules only when convenient. What does this show?",
  options: [
    "Commitment",
    "Consistency",
    "Lack of discipline",
    "Obedience"
  ],
  answer: "Lack of discipline"
},
{
  question: "Which of the following best explains why honesty is valued in religion?",
  options: [
    "It promotes deception",
    "It builds trust and integrity",
    "It creates confusion",
    "It reduces responsibility"
  ],
  answer: "It builds trust and integrity"
},
{
  question: "A person lies to gain advantage over others. What is the likely result?",
  options: [
    "Trust",
    "Respect",
    "Loss of credibility",
    "Unity"
  ],
  answer: "Loss of credibility"
},
{
  question: "Which of the following best explains why humility is important in leadership?",
  options: [
    "It promotes pride",
    "It allows leaders to serve others effectively",
    "It weakens authority",
    "It reduces influence"
  ],
  answer: "It allows leaders to serve others effectively"
},
{
  question: "A leader ignores advice and believes only in his ideas. Which value is lacking?",
  options: [
    "Confidence",
    "Humility",
    "Faith",
    "Obedience"
  ],
  answer: "Humility"
},
{
  question: "Which of the following best explains why religious festivals promote unity?",
  options: [
    "They isolate people",
    "They bring people together for shared beliefs",
    "They encourage conflict",
    "They reduce interaction"
  ],
  answer: "They bring people together for shared beliefs"
},
{
  question: "A person attends festivals but continues immoral behaviour. What does this indicate?",
  options: [
    "True commitment",
    "Spiritual maturity",
    "Lack of transformation",
    "Strong faith"
  ],
  answer: "Lack of transformation"
},
{
  question: "Which of the following best explains why work is considered a form of worship?",
  options: [
    "It replaces prayer",
    "It reflects obedience and responsibility",
    "It is done only for money",
    "It is not important"
  ],
  answer: "It reflects obedience and responsibility"
},
{
  question: "A person refuses to work but expects success. Which teaching is ignored?",
  options: [
    "Faith",
    "Hard work",
    "Worship",
    "Prayer"
  ],
  answer: "Hard work"
},
{
  question: "Which of the following best explains the relationship between money and morality?",
  options: [
    "Money determines character",
    "Money should be used responsibly",
    "Money replaces religion",
    "Money has no value"
  ],
  answer: "Money should be used responsibly"
},
{
  question: "A student spends all money carelessly and borrows frequently. What is lacking?",
  options: [
    "Wealth",
    "Financial discipline",
    "Faith",
    "Knowledge"
  ],
  answer: "Financial discipline"
},
{
  question: "Which of the following best explains why peer pressure affects moral decisions?",
  options: [
    "People always make independent choices",
    "Individuals may follow others to be accepted",
    "Peer influence has no effect",
    "Friends always guide correctly"
  ],
  answer: "Individuals may follow others to be accepted"
},
{
  question: "A student joins bad friends despite knowing the consequences. What is lacking?",
  options: [
    "Knowledge",
    "Self-control",
    "Faith",
    "Strength"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why substance abuse is dangerous?",
  options: [
    "It improves health",
    "It destroys physical and moral well-being",
    "It increases discipline",
    "It promotes responsibility"
  ],
  answer: "It destroys physical and moral well-being"
},
{
  question: "A person continues harmful habits despite warnings. What does this show?",
  options: [
    "Wisdom",
    "Discipline",
    "Lack of self-control",
    "Faith"
  ],
  answer: "Lack of self-control"
},
{
  question: "Which of the following best explains judgment in religion?",
  options: [
    "Ignoring actions",
    "Evaluation of actions with consequences",
    "Avoiding responsibility",
    "Blaming others"
  ],
  answer: "Evaluation of actions with consequences"
},
{
  question: "Which of the following best explains why good deeds are rewarded?",
  options: [
    "To create competition",
    "To encourage righteous living",
    "To punish people",
    "To promote pride"
  ],
  answer: "To encourage righteous living"
},
{
  question: "A person claims to love God but constantly harms others. What does this suggest?",
  options: [
    "True faith",
    "Complete obedience",
    "Lack of practical love",
    "Strong commitment"
  ],
  answer: "Lack of practical love"
},
{
  question: "Which of the following best explains why love is central in religion?",
  options: [
    "It promotes selfishness",
    "It guides relationships and behaviour",
    "It reduces responsibility",
    "It creates division"
  ],
  answer: "It guides relationships and behaviour"
},
{
  question: "A student refuses to help a struggling classmate. Which value is lacking?",
  options: [
    "Kindness",
    "Faith",
    "Obedience",
    "Knowledge"
  ],
  answer: "Kindness"
},
{
  question: "Which of the following best explains why truthfulness is important?",
  options: [
    "It confuses others",
    "It builds trust in society",
    "It promotes fear",
    "It reduces communication"
  ],
  answer: "It builds trust in society"
},
{
  question: "A person lies repeatedly to gain benefits. What is the likely long-term effect?",
  options: [
    "Respect",
    "Trust",
    "Loss of reputation",
    "Unity"
  ],
  answer: "Loss of reputation"
},
{
  question: "Which of the following best explains moral courage?",
  options: [
    "Following others blindly",
    "Standing for what is right despite pressure",
    "Avoiding decisions",
    "Ignoring rules"
  ],
  answer: "Standing for what is right despite pressure"
},
{
  question: "A student refuses to cheat even when everyone else is doing so. What is demonstrated?",
  options: [
    "Fear",
    "Weakness",
    "Moral courage",
    "Isolation"
  ],
  answer: "Moral courage"
},
{
  question: "Which of the following best explains why discipline is necessary?",
  options: [
    "It limits freedom",
    "It promotes orderly living",
    "It creates fear",
    "It encourages laziness"
  ],
  answer: "It promotes orderly living"
},
{
  question: "A person ignores rules and acts impulsively. Which value is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why respect is important?",
  options: [
    "It causes division",
    "It promotes peaceful coexistence",
    "It reduces communication",
    "It creates conflict"
  ],
  answer: "It promotes peaceful coexistence"
},
{
  question: "A student insults elders publicly. What is the likely consequence?",
  options: [
    "Respect",
    "Honor",
    "Disrespect and punishment",
    "Reward"
  ],
  answer: "Disrespect and punishment"
},
{
  question: "Which of the following best explains self-respect?",
  options: [
    "Ignoring others",
    "Valuing oneself and acting responsibly",
    "Boasting about achievements",
    "Comparing with others"
  ],
  answer: "Valuing oneself and acting responsibly"
},
{
  question: "A person engages in immoral behaviour despite knowing its consequences. What is lacking?",
  options: [
    "Knowledge",
    "Self-control",
    "Faith",
    "Wisdom"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why patience is necessary in decision-making?",
  options: [
    "It delays progress",
    "It allows careful thinking before action",
    "It promotes mistakes",
    "It avoids responsibility"
  ],
  answer: "It allows careful thinking before action"
},
{
  question: "A student reacts angrily without thinking. What is lacking?",
  options: [
    "Faith",
    "Patience",
    "Kindness",
    "Obedience"
  ],
  answer: "Patience"
},
{
  question: "Which of the following best explains why envy is harmful?",
  options: [
    "It promotes happiness",
    "It creates dissatisfaction and conflict",
    "It builds relationships",
    "It encourages sharing"
  ],
  answer: "It creates dissatisfaction and conflict"
},
{
  question: "A person feels unhappy about others� success. Which value is lacking?",
  options: [
    "Contentment",
    "Faith",
    "Knowledge",
    "Obedience"
  ],
  answer: "Contentment"
},
{
  question: "Which of the following best explains why responsibility is important?",
  options: [
    "It promotes laziness",
    "It ensures accountability for actions",
    "It reduces effort",
    "It avoids decision-making"
  ],
  answer: "It ensures accountability for actions"
},
{
  question: "A student neglects duties and blames others. What is lacking?",
  options: [
    "Responsibility",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Responsibility"
},
{
  question: "Which of the following best explains why moral education is important?",
  options: [
    "It limits freedom",
    "It shapes behaviour and character",
    "It promotes confusion",
    "It reduces knowledge"
  ],
  answer: "It shapes behaviour and character"
},
{
  question: "A person prays regularly but cheats in business. What is the correct assessment?",
  options: [
    "He is fully obedient",
    "He separates worship from behaviour",
    "He is disciplined",
    "He is truthful"
  ],
  answer: "He separates worship from behaviour"
},
{
  question: "Which of the following best explains true righteousness?",
  options: [
    "Performing rituals only",
    "Living according to moral and religious principles",
    "Avoiding people",
    "Attending festivals only"
  ],
  answer: "Living according to moral and religious principles"
},
{
  question: "A student gives to charity but insults others. What does this indicate?",
  options: [
    "Complete goodness",
    "Balanced character",
    "Inconsistency in behaviour",
    "Strong faith"
  ],
  answer: "Inconsistency in behaviour"
},
{
  question: "Which of the following best explains why intentions matter in religion?",
  options: [
    "Actions are not important",
    "Intentions determine the value of actions",
    "Intentions are irrelevant",
    "Actions alone matter"
  ],
  answer: "Intentions determine the value of actions"
},
{
  question: "A person helps others only to gain recognition. What is lacking?",
  options: [
    "Strength",
    "Sincerity",
    "Knowledge",
    "Patience"
  ],
  answer: "Sincerity"
},
{
  question: "Which of the following best explains why hypocrisy is condemned?",
  options: [
    "It promotes honesty",
    "It shows contradiction between belief and action",
    "It builds trust",
    "It strengthens faith"
  ],
  answer: "It shows contradiction between belief and action"
},
{
  question: "A student behaves well in public but badly in private. What is demonstrated?",
  options: [
    "Integrity",
    "Hypocrisy",
    "Faithfulness",
    "Patience"
  ],
  answer: "Hypocrisy"
},
{
  question: "Which of the following best explains selflessness?",
  options: [
    "Putting oneself first always",
    "Thinking about the needs of others before oneself",
    "Ignoring responsibilities",
    "Avoiding people"
  ],
  answer: "Thinking about the needs of others before oneself"
},
{
  question: "A person sacrifices personal comfort to help others. Which value is shown?",
  options: [
    "Greed",
    "Selflessness",
    "Pride",
    "Fear"
  ],
  answer: "Selflessness"
},
{
  question: "Which of the following best explains why moral values must be practiced consistently?",
  options: [
    "To impress others",
    "To maintain good character at all times",
    "To avoid punishment only",
    "To gain popularity"
  ],
  answer: "To maintain good character at all times"
},
{
  question: "A person behaves well only when monitored. What is lacking?",
  options: [
    "Faith",
    "Integrity",
    "Strength",
    "Knowledge"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains why leaders must be role models?",
  options: [
    "They are above rules",
    "Their behaviour influences others",
    "They control society",
    "They avoid responsibility"
  ],
  answer: "Their behaviour influences others"
},
{
  question: "A leader acts unjustly and selfishly. What is the likely effect?",
  options: [
    "Trust",
    "Unity",
    "Loss of respect",
    "Peace"
  ],
  answer: "Loss of respect"
},
{
  question: "Which of the following best explains why truth must be upheld?",
  options: [
    "It promotes deception",
    "It builds trust and justice",
    "It creates confusion",
    "It encourages dishonesty"
  ],
  answer: "It builds trust and justice"
},
{
  question: "A person hides the truth to avoid consequences. What is demonstrated?",
  options: [
    "Honesty",
    "Dishonesty",
    "Patience",
    "Faith"
  ],
  answer: "Dishonesty"
},
{
  question: "Which of the following best explains why discipline is linked to success?",
  options: [
    "It limits effort",
    "It promotes consistency and focus",
    "It delays progress",
    "It creates confusion"
  ],
  answer: "It promotes consistency and focus"
},
{
  question: "A student fails due to lack of focus and planning. What is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why choices have consequences?",
  options: [
    "Actions have no results",
    "Every action leads to an outcome",
    "Choices are irrelevant",
    "Results are random"
  ],
  answer: "Every action leads to an outcome"
},
{
  question: "A person repeatedly makes bad choices despite warnings. What does this show?",
  options: [
    "Wisdom",
    "Stubbornness",
    "Faith",
    "Humility"
  ],
  answer: "Stubbornness"
},
{
  question: "Which of the following best explains why moral discipline is important for society?",
  options: [
    "It promotes disorder",
    "It ensures peaceful and orderly living",
    "It reduces cooperation",
    "It limits development"
  ],
  answer: "It ensures peaceful and orderly living"
},
{
  question: "A person gives alms publicly to gain attention. What moral issue is involved?",
  options: [
    "Generosity",
    "Hypocrisy",
    "Kindness",
    "Faithfulness"
  ],
  answer: "Hypocrisy"
},
{
  question: "Which of the following best explains sincerity in religious life?",
  options: [
    "Acting to please others",
    "Doing good without expecting reward",
    "Seeking recognition always",
    "Following friends blindly"
  ],
  answer: "Doing good without expecting reward"
},
{
  question: "A student behaves well only when teachers are present. Which value is lacking?",
  options: [
    "Integrity",
    "Knowledge",
    "Strength",
    "Faith"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains why good deeds must be consistent?",
  options: [
    "To gain popularity",
    "To build strong character",
    "To avoid punishment only",
    "To impress others"
  ],
  answer: "To build strong character"
},
{
  question: "A person refuses to forgive despite repeated apologies. What is lacking?",
  options: [
    "Faith",
    "Forgiveness",
    "Patience",
    "Tolerance"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains the consequence of unforgiveness?",
  options: [
    "Peace",
    "Unity",
    "Bitterness and conflict",
    "Happiness"
  ],
  answer: "Bitterness and conflict"
},
{
  question: "A student helps others only when there is a reward. What is lacking?",
  options: [
    "Kindness",
    "Sincerity",
    "Knowledge",
    "Obedience"
  ],
  answer: "Sincerity"
},
{
  question: "Which of the following best explains why respect for elders is important?",
  options: [
    "To show weakness",
    "To maintain social harmony",
    "To avoid responsibility",
    "To reduce communication"
  ],
  answer: "To maintain social harmony"
},
{
  question: "A person ignores advice from elders and suffers consequences. What is the lesson?",
  options: [
    "Ignore guidance always",
    "Value wisdom and experience",
    "Avoid responsibility",
    "Act independently always"
  ],
  answer: "Value wisdom and experience"
},
{
  question: "Which of the following best explains why moral laws guide behaviour?",
  options: [
    "They promote confusion",
    "They direct actions towards good living",
    "They reduce responsibility",
    "They encourage laziness"
  ],
  answer: "They direct actions towards good living"
},
{
  question: "A student disobeys rules and blames others. What is lacking?",
  options: [
    "Responsibility",
    "Faith",
    "Tolerance",
    "Kindness"
  ],
  answer: "Responsibility"
},
{
  question: "Which of the following best explains why discipline leads to success?",
  options: [
    "It reduces effort",
    "It ensures consistency and focus",
    "It limits achievement",
    "It promotes laziness"
  ],
  answer: "It ensures consistency and focus"
},
{
  question: "A person wastes time and fails to achieve goals. What is lacking?",
  options: [
    "Time management",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Time management"
},
{
  question: "Which of the following best explains why greed is discouraged?",
  options: [
    "It promotes sharing",
    "It leads to selfishness and conflict",
    "It builds unity",
    "It encourages kindness"
  ],
  answer: "It leads to selfishness and conflict"
},
{
  question: "A person always wants more than needed and refuses to share. What is demonstrated?",
  options: [
    "Contentment",
    "Greed",
    "Kindness",
    "Humility"
  ],
  answer: "Greed"
},
{
  question: "Which of the following best explains why contentment is important?",
  options: [
    "It creates dissatisfaction",
    "It promotes peace and happiness",
    "It reduces effort",
    "It encourages laziness"
  ],
  answer: "It promotes peace and happiness"
},
{
  question: "A student constantly compares himself with others and feels unhappy. What is lacking?",
  options: [
    "Contentment",
    "Faith",
    "Patience",
    "Obedience"
  ],
  answer: "Contentment"
},
{
  question: "Which of the following best explains why patience is necessary?",
  options: [
    "It delays progress",
    "It helps in making wise decisions",
    "It promotes mistakes",
    "It reduces effort"
  ],
  answer: "It helps in making wise decisions"
},
{
  question: "A person reacts angrily without thinking. What is lacking?",
  options: [
    "Patience",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Patience"
},
{
  question: "Which of the following best explains why moral education is important?",
  options: [
    "It limits freedom",
    "It shapes character and behaviour",
    "It promotes confusion",
    "It reduces knowledge"
  ],
  answer: "It shapes character and behaviour"
},
{
  question: "A person claims to be humble but always seeks praise. What does this show?",
  options: [
    "True humility",
    "Pride",
    "Kindness",
    "Faith"
  ],
  answer: "Pride"
},
{
  question: "Which of the following best explains true humility?",
  options: [
    "Looking down on others",
    "Recognizing one's strengths without arrogance",
    "Avoiding responsibility",
    "Seeking attention"
  ],
  answer: "Recognizing one's strengths without arrogance"
},
{
  question: "A student refuses to apologize after wrongdoing. Which value is lacking?",
  options: [
    "Repentance",
    "Knowledge",
    "Faith",
    "Patience"
  ],
  answer: "Repentance"
},
{
  question: "Which of the following best explains why repentance is important?",
  options: [
    "It encourages wrongdoing",
    "It leads to change and forgiveness",
    "It avoids responsibility",
    "It promotes pride"
  ],
  answer: "It leads to change and forgiveness"
},
{
  question: "A person admits wrongdoing but continues the same behaviour. What is demonstrated?",
  options: [
    "True repentance",
    "Lack of change",
    "Humility",
    "Obedience"
  ],
  answer: "Lack of change"
},
{
  question: "Which of the following best explains why honesty is essential in society?",
  options: [
    "It creates confusion",
    "It builds trust and fairness",
    "It promotes dishonesty",
    "It reduces cooperation"
  ],
  answer: "It builds trust and fairness"
},
{
  question: "A student lies to escape punishment. What is the likely consequence?",
  options: [
    "Trust",
    "Respect",
    "Loss of credibility",
    "Reward"
  ],
  answer: "Loss of credibility"
},
{
  question: "Which of the following best explains why respect must be mutual?",
  options: [
    "It promotes inequality",
    "It ensures peaceful relationships",
    "It creates conflict",
    "It limits communication"
  ],
  answer: "It ensures peaceful relationships"
},
{
  question: "A person respects others but is disrespected in return. What is the best response?",
  options: [
    "Respond with disrespect",
    "Maintain good behaviour",
    "Ignore all people",
    "Seek revenge"
  ],
  answer: "Maintain good behaviour"
},
{
  question: "Which of the following best explains why tolerance is important?",
  options: [
    "It promotes conflict",
    "It allows peaceful coexistence",
    "It reduces interaction",
    "It limits understanding"
  ],
  answer: "It allows peaceful coexistence"
},
{
  question: "A community experiences conflict due to religious differences. What is lacking?",
  options: [
    "Faith",
    "Tolerance",
    "Worship",
    "Obedience"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following best explains why discipline is necessary in life?",
  options: [
    "It limits freedom",
    "It promotes order and success",
    "It reduces effort",
    "It creates confusion"
  ],
  answer: "It promotes order and success"
},
{
  question: "A student consistently ignores rules and instructions. What is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Knowledge",
    "Kindness"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why self-control is important?",
  options: [
    "It limits freedom",
    "It helps manage behaviour and emotions",
    "It reduces responsibility",
    "It creates fear"
  ],
  answer: "It helps manage behaviour and emotions"
},
{
  question: "A person reacts emotionally without thinking. What is lacking?",
  options: [
    "Self-control",
    "Faith",
    "Patience",
    "Tolerance"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why forgiveness promotes peace?",
  options: [
    "It encourages revenge",
    "It reduces anger and conflict",
    "It creates confusion",
    "It weakens relationships"
  ],
  answer: "It reduces anger and conflict"
},
{
  question: "A person holds grudges for a long time. What is the likely effect?",
  options: [
    "Peace",
    "Unity",
    "Bitterness",
    "Happiness"
  ],
  answer: "Bitterness"
},
{
  question: "Which of the following best explains why kindness is important?",
  options: [
    "It promotes selfishness",
    "It builds strong relationships",
    "It creates conflict",
    "It reduces communication"
  ],
  answer: "It builds strong relationships"
},
{
  question: "A student refuses to help others in need. What is lacking?",
  options: [
    "Kindness",
    "Faith",
    "Knowledge",
    "Obedience"
  ],
  answer: "Kindness"
},
{
  question: "Which of the following best explains why moral discipline is important?",
  options: [
    "It promotes disorder",
    "It ensures good behaviour in society",
    "It reduces responsibility",
    "It creates confusion"
  ],
  answer: "It ensures good behaviour in society"
},
{
  question: "A person claims to be truthful but hides important facts. What does this indicate?",
  options: [
    "Honesty",
    "Partial honesty",
    "Integrity",
    "Faithfulness"
  ],
  answer: "Partial honesty"
},
{
  question: "Which of the following best explains integrity?",
  options: [
    "Doing what is right only when observed",
    "Being consistent in doing what is right at all times",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Being consistent in doing what is right at all times"
},
{
  question: "A student helps others only when it benefits him. What is lacking?",
  options: [
    "Kindness",
    "Selflessness",
    "Knowledge",
    "Patience"
  ],
  answer: "Selflessness"
},
{
  question: "Which of the following best explains why greed destroys relationships?",
  options: [
    "It promotes sharing",
    "It leads to selfish actions",
    "It builds trust",
    "It encourages kindness"
  ],
  answer: "It leads to selfish actions"
},
{
  question: "A person refuses to accept correction despite clear mistakes. What is lacking?",
  options: [
    "Humility",
    "Faith",
    "Patience",
    "Kindness"
  ],
  answer: "Humility"
},
{
  question: "Which of the following best explains why humility improves relationships?",
  options: [
    "It promotes pride",
    "It allows acceptance of others",
    "It reduces communication",
    "It creates conflict"
  ],
  answer: "It allows acceptance of others"
},
{
  question: "A student constantly interrupts others during discussions. What is lacking?",
  options: [
    "Respect",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Respect"
},
{
  question: "Which of the following best explains why respect is necessary in communication?",
  options: [
    "It creates misunderstanding",
    "It promotes effective interaction",
    "It reduces listening",
    "It causes conflict"
  ],
  answer: "It promotes effective interaction"
},
{
  question: "A person refuses to forgive even after receiving forgiveness. What is lacking?",
  options: [
    "Justice",
    "Forgiveness",
    "Faith",
    "Discipline"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains why forgiveness benefits the offender?",
  options: [
    "It encourages wrongdoing",
    "It gives opportunity for change",
    "It promotes punishment",
    "It creates fear"
  ],
  answer: "It gives opportunity for change"
},
{
  question: "A student ignores responsibilities and focuses only on pleasure. What is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why discipline is important in achieving goals?",
  options: [
    "It delays progress",
    "It ensures focus and persistence",
    "It reduces effort",
    "It promotes confusion"
  ],
  answer: "It ensures focus and persistence"
},
{
  question: "A person makes decisions without considering consequences. What is lacking?",
  options: [
    "Wisdom",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Wisdom"
},
{
  question: "Which of the following best explains wisdom?",
  options: [
    "Accumulation of wealth",
    "Ability to make good decisions",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Ability to make good decisions"
},
{
  question: "A student is influenced easily by friends to do wrong things. What is lacking?",
  options: [
    "Self-control",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why self-control is necessary in resisting peer pressure?",
  options: [
    "It promotes weakness",
    "It helps maintain good behaviour",
    "It reduces responsibility",
    "It creates fear"
  ],
  answer: "It helps maintain good behaviour"
},
{
  question: "A person wastes resources without thinking of others. What is lacking?",
  options: [
    "Stewardship",
    "Faith",
    "Kindness",
    "Patience"
  ],
  answer: "Stewardship"
},
{
  question: "Which of the following best explains stewardship in daily life?",
  options: [
    "Using resources carelessly",
    "Managing resources responsibly",
    "Avoiding responsibility",
    "Depending on others"
  ],
  answer: "Managing resources responsibly"
},
{
  question: "A person judges others harshly but ignores personal faults. What is lacking?",
  options: [
    "Fairness",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Fairness"
},
{
  question: "Which of the following best explains fairness?",
  options: [
    "Treating people unequally",
    "Judging people justly and equally",
    "Ignoring others",
    "Avoiding decisions"
  ],
  answer: "Judging people justly and equally"
},
{
  question: "A person gives generously but treats people with disrespect. What does this reveal?",
  options: [
    "Complete righteousness",
    "Balanced character",
    "Moral inconsistency",
    "Strong discipline"
  ],
  answer: "Moral inconsistency"
},
{
  question: "Which of the following best explains why good actions alone are not enough in religion?",
  options: [
    "Actions are not important",
    "Actions must be supported by good character",
    "Only intentions matter",
    "Only worship matters"
  ],
  answer: "Actions must be supported by good character"
},
{
  question: "A student obeys rules in school but disobeys at home. What does this show?",
  options: [
    "Consistency",
    "Integrity",
    "Double standards",
    "Faithfulness"
  ],
  answer: "Double standards"
},
{
  question: "Which of the following best explains why consistency is important in moral life?",
  options: [
    "It promotes confusion",
    "It builds strong and reliable character",
    "It reduces responsibility",
    "It encourages dishonesty"
  ],
  answer: "It builds strong and reliable character"
},
{
  question: "A person forgives but continues to hold resentment. What is lacking?",
  options: [
    "True forgiveness",
    "Patience",
    "Kindness",
    "Faith"
  ],
  answer: "True forgiveness"
},
{
  question: "Which of the following best explains why resentment is harmful?",
  options: [
    "It promotes peace",
    "It damages relationships",
    "It builds trust",
    "It encourages unity"
  ],
  answer: "It damages relationships"
},
{
  question: "A student always wants recognition for good deeds. What is lacking?",
  options: [
    "Humility",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Humility"
},
{
  question: "Which of the following best explains why humility strengthens leadership?",
  options: [
    "It reduces authority",
    "It encourages listening and service",
    "It promotes pride",
    "It limits influence"
  ],
  answer: "It encourages listening and service"
},
{
  question: "A person avoids helping others because it is inconvenient. What is lacking?",
  options: [
    "Kindness",
    "Faith",
    "Patience",
    "Tolerance"
  ],
  answer: "Kindness"
},
{
  question: "Which of the following best explains why kindness is essential in society?",
  options: [
    "It creates conflict",
    "It promotes cooperation and harmony",
    "It reduces interaction",
    "It encourages selfishness"
  ],
  answer: "It promotes cooperation and harmony"
},
{
  question: "A student is easily influenced by friends to act wrongly. What is lacking?",
  options: [
    "Self-control",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why self-control is necessary for moral living?",
  options: [
    "It limits freedom",
    "It helps regulate actions and decisions",
    "It reduces responsibility",
    "It promotes fear"
  ],
  answer: "It helps regulate actions and decisions"
},
{
  question: "A person wastes money without planning. What is lacking?",
  options: [
    "Financial discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Financial discipline"
},
{
  question: "Which of the following best explains why financial discipline is important?",
  options: [
    "It promotes waste",
    "It ensures proper use of resources",
    "It reduces planning",
    "It encourages borrowing"
  ],
  answer: "It ensures proper use of resources"
},
{
  question: "A student ignores advice and repeats mistakes. What is lacking?",
  options: [
    "Wisdom",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Wisdom"
},
{
  question: "Which of the following best explains wisdom in decision-making?",
  options: [
    "Acting quickly without thinking",
    "Making thoughtful and informed choices",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Making thoughtful and informed choices"
},
{
  question: "A person treats others unfairly based on personal feelings. What is lacking?",
  options: [
    "Fairness",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Fairness"
},
{
  question: "Which of the following best explains why fairness is important in society?",
  options: [
    "It promotes conflict",
    "It ensures justice and equality",
    "It reduces interaction",
    "It encourages bias"
  ],
  answer: "It ensures justice and equality"
},
{
  question: "A person is quick to judge others without understanding them. What is lacking?",
  options: [
    "Understanding",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Understanding"
},
{
  question: "Which of the following best explains why understanding others is important?",
  options: [
    "It creates confusion",
    "It promotes empathy and peaceful relationships",
    "It reduces communication",
    "It encourages division"
  ],
  answer: "It promotes empathy and peaceful relationships"
},
{
  question: "A person appears generous but refuses to help when it is inconvenient. What does this indicate?",
  options: [
    "True generosity",
    "Conditional kindness",
    "Strong faith",
    "Integrity"
  ],
  answer: "Conditional kindness"
},
{
  question: "Which of the following best explains why true goodness must be consistent?",
  options: [
    "To gain praise",
    "To maintain integrity in all situations",
    "To impress others",
    "To avoid punishment only"
  ],
  answer: "To maintain integrity in all situations"
},
{
  question: "A student behaves differently depending on who is watching. What is demonstrated?",
  options: [
    "Integrity",
    "Consistency",
    "Hypocrisy",
    "Discipline"
  ],
  answer: "Hypocrisy"
},
{
  question: "Which of the following best explains why hypocrisy is harmful?",
  options: [
    "It promotes honesty",
    "It destroys trust and credibility",
    "It builds unity",
    "It encourages discipline"
  ],
  answer: "It destroys trust and credibility"
},
{
  question: "A person forgives outwardly but seeks revenge secretly. What is lacking?",
  options: [
    "Patience",
    "True forgiveness",
    "Kindness",
    "Faith"
  ],
  answer: "True forgiveness"
},
{
  question: "Which of the following best explains why revenge is discouraged?",
  options: [
    "It promotes peace",
    "It leads to continued conflict",
    "It builds relationships",
    "It encourages kindness"
  ],
  answer: "It leads to continued conflict"
},
{
  question: "A student refuses to admit mistakes even when proven wrong. What is lacking?",
  options: [
    "Humility",
    "Faith",
    "Knowledge",
    "Tolerance"
  ],
  answer: "Humility"
},
{
  question: "Which of the following best explains why admitting mistakes is important?",
  options: [
    "It shows weakness",
    "It allows correction and growth",
    "It reduces respect",
    "It creates confusion"
  ],
  answer: "It allows correction and growth"
},
{
  question: "A person helps others but expects something in return. What is lacking?",
  options: [
    "Selflessness",
    "Kindness",
    "Faith",
    "Patience"
  ],
  answer: "Selflessness"
},
{
  question: "Which of the following best explains why selflessness strengthens relationships?",
  options: [
    "It promotes selfishness",
    "It builds trust and unity",
    "It reduces communication",
    "It encourages competition"
  ],
  answer: "It builds trust and unity"
},
{
  question: "A student wastes time and misses opportunities. What is lacking?",
  options: [
    "Time management",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Time management"
},
{
  question: "Which of the following best explains why time management is important?",
  options: [
    "It limits freedom",
    "It improves productivity and success",
    "It reduces effort",
    "It creates confusion"
  ],
  answer: "It improves productivity and success"
},
{
  question: "A person spends beyond income and accumulates debt. What is lacking?",
  options: [
    "Financial discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Financial discipline"
},
{
  question: "Which of the following best explains why financial discipline is necessary?",
  options: [
    "It promotes waste",
    "It ensures stability and responsible living",
    "It reduces planning",
    "It encourages borrowing"
  ],
  answer: "It ensures stability and responsible living"
},
{
  question: "A student ignores consequences and makes impulsive decisions. What is lacking?",
  options: [
    "Wisdom",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Wisdom"
},
{
  question: "Which of the following best explains wisdom in daily life?",
  options: [
    "Acting without thinking",
    "Making careful and informed decisions",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Making careful and informed decisions"
},
{
  question: "A person treats others unfairly due to personal bias. What is lacking?",
  options: [
    "Fairness",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Fairness"
},
{
  question: "Which of the following best explains why fairness promotes justice?",
  options: [
    "It promotes inequality",
    "It ensures equal treatment",
    "It reduces communication",
    "It encourages conflict"
  ],
  answer: "It ensures equal treatment"
},
{
  question: "A student judges others without understanding their situation. What is lacking?",
  options: [
    "Empathy",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Empathy"
},
{
  question: "Which of the following best explains empathy?",
  options: [
    "Ignoring others� feelings",
    "Understanding and sharing others� feelings",
    "Avoiding interaction",
    "Judging quickly"
  ],
  answer: "Understanding and sharing others� feelings"
},
{
  question: "A person obeys religious teachings publicly but ignores them privately. What does this indicate?",
  options: [
    "Integrity",
    "Consistency",
    "Hypocrisy",
    "Faithfulness"
  ],
  answer: "Hypocrisy"
},
{
  question: "Which of the following best explains why integrity is important in private life?",
  options: [
    "To impress others",
    "To maintain moral consistency even when unseen",
    "To gain popularity",
    "To avoid punishment only"
  ],
  answer: "To maintain moral consistency even when unseen"
},
{
  question: "A student refuses to accept correction and repeats mistakes. What is lacking?",
  options: [
    "Humility",
    "Faith",
    "Patience",
    "Kindness"
  ],
  answer: "Humility"
},
{
  question: "Which of the following best explains why humility is essential for learning?",
  options: [
    "It promotes pride",
    "It allows acceptance of correction",
    "It reduces knowledge",
    "It creates confusion"
  ],
  answer: "It allows acceptance of correction"
},
{
  question: "A person helps others only when it benefits them. What is lacking?",
  options: [
    "Selflessness",
    "Kindness",
    "Faith",
    "Tolerance"
  ],
  answer: "Selflessness"
},
{
  question: "Which of the following best explains why selflessness promotes unity?",
  options: [
    "It promotes selfishness",
    "It encourages cooperation and trust",
    "It reduces interaction",
    "It creates conflict"
  ],
  answer: "It encourages cooperation and trust"
},
{
  question: "A student delays important tasks until it is too late. What is lacking?",
  options: [
    "Time management",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Time management"
},
{
  question: "Which of the following best explains procrastination?",
  options: [
    "Planning effectively",
    "Delaying tasks unnecessarily",
    "Working consistently",
    "Managing time wisely"
  ],
  answer: "Delaying tasks unnecessarily"
},
{
  question: "A person spends money carelessly and later regrets it. What is lacking?",
  options: [
    "Financial discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Financial discipline"
},
{
  question: "Which of the following best explains why budgeting is important?",
  options: [
    "It promotes waste",
    "It helps control spending",
    "It reduces planning",
    "It encourages borrowing"
  ],
  answer: "It helps control spending"
},
{
  question: "A student acts without considering consequences. What is lacking?",
  options: [
    "Wisdom",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Wisdom"
},
{
  question: "Which of the following best explains foresight?",
  options: [
    "Ignoring consequences",
    "Thinking ahead before acting",
    "Acting impulsively",
    "Avoiding responsibility"
  ],
  answer: "Thinking ahead before acting"
},
{
  question: "A person treats others unfairly based on personal interest. What is lacking?",
  options: [
    "Fairness",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Fairness"
},
{
  question: "Which of the following best explains justice?",
  options: [
    "Treating people unequally",
    "Giving each person what they deserve",
    "Ignoring others",
    "Avoiding decisions"
  ],
  answer: "Giving each person what they deserve"
},
{
  question: "A student fails to understand others� feelings and reacts harshly. What is lacking?",
  options: [
    "Empathy",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Empathy"
},
{
  question: "Which of the following best explains emotional intelligence?",
  options: [
    "Ignoring emotions",
    "Understanding and managing emotions effectively",
    "Avoiding interaction",
    "Reacting impulsively"
  ],
  answer: "Understanding and managing emotions effectively"
},
{
  question: "A person refuses to admit wrongdoing and blames others. What is lacking?",
  options: [
    "Responsibility",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Responsibility"
},
{
  question: "Which of the following best explains accountability?",
  options: [
    "Avoiding responsibility",
    "Accepting responsibility for actions",
    "Blaming others",
    "Ignoring consequences"
  ],
  answer: "Accepting responsibility for actions"
},
{
  question: "A person seeks revenge instead of resolving conflict peacefully. What is lacking?",
  options: [
    "Forgiveness",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains reconciliation?",
  options: [
    "Continuing conflict",
    "Restoring broken relationships",
    "Ignoring problems",
    "Seeking revenge"
  ],
  answer: "Restoring broken relationships"
},
{
  question: "Which of the following best describes the biblical account of creation?",
  options: [
    "Creation happened in one day",
    "God created the world in six days and rested on the seventh",
    "Humans created the world",
    "Creation occurred by accident"
  ],
  answer: "God created the world in six days and rested on the seventh"
},
{
  question: "Which of the following is a teaching from the Qur�an about creation?",
  options: [
    "The world created itself",
    "Allah created everything with purpose",
    "Humans created nature",
    "Creation has no meaning"
  ],
  answer: "Allah created everything with purpose"
},
{
  question: "Which of the following best explains African Traditional views of creation?",
  options: [
    "No belief in creation",
    "God created the world through intermediaries",
    "Humans created the world",
    "Creation is not important"
  ],
  answer: "God created the world through intermediaries"
},
{
  question: "Which of the following is the first pillar of Islam?",
  options: [
    "Salat",
    "Zakat",
    "Shahada",
    "Hajj"
  ],
  answer: "Shahada"
},
{
  question: "Which of the following refers to the five daily prayers in Islam?",
  options: [
    "Zakat",
    "Salat",
    "Hajj",
    "Sawm"
  ],
  answer: "Salat"
},
{
  question: "Which of the following is a form of charity in Islam?",
  options: [
    "Salat",
    "Zakat",
    "Sawm",
    "Hajj"
  ],
  answer: "Zakat"
},
{
  question: "Which of the following is the Christian sacrament involving water?",
  options: [
    "Communion",
    "Baptism",
    "Confirmation",
    "Marriage"
  ],
  answer: "Baptism"
},
{
  question: "Which of the following best explains Holy Communion?",
  options: [
    "A festival only",
    "A remembrance of Jesus Christ's sacrifice",
    "A prayer session",
    "A social gathering"
  ],
  answer: "A remembrance of Jesus Christ's sacrifice"
},
{
  question: "Which of the following is a practice in African Traditional Religion?",
  options: [
    "Reading the Bible",
    "Observing shrine rituals",
    "Facing Mecca",
    "Reciting the Qur�an"
  ],
  answer: "Observing shrine rituals"
},
{
  question: "Which of the following is a role of a father in the family?",
  options: [
    "Ignoring responsibilities",
    "Providing and protecting the family",
    "Avoiding decisions",
    "Following children"
  ],
  answer: "Providing and protecting the family"
},
{
  question: "Which of the following is a role of a mother in the family?",
  options: [
    "Neglecting children",
    "Caring and nurturing the family",
    "Avoiding responsibilities",
    "Ignoring household duties"
  ],
  answer: "Caring and nurturing the family"
},
{
  question: "Which of the following is a responsibility of children?",
  options: [
    "Disobeying parents",
    "Respecting and helping parents",
    "Avoiding school",
    "Ignoring elders"
  ],
  answer: "Respecting and helping parents"
},
{
  question: "Which of the following best explains self-employment?",
  options: [
    "Working for government only",
    "Working for oneself",
    "Avoiding work",
    "Depending on others"
  ],
  answer: "Working for oneself"
},
{
  question: "Which of the following is a type of work?",
  options: [
    "Laziness",
    "Farming",
    "Ignoring duties",
    "Avoiding responsibility"
  ],
  answer: "Farming"
},
{
  question: "Which of the following best explains the significance of Christmas?",
  options: [
    "Birth of Prophet Muhammad",
    "Birth of Jesus Christ",
    "End of fasting",
    "Traditional celebration"
  ],
  answer: "Birth of Jesus Christ"
},
{
  question: "Which of the following best explains the significance of Eid-ul-Fitr?",
  options: [
    "Birth of Jesus",
    "End of Ramadan fasting",
    "Traditional festival",
    "Harvest celebration"
  ],
  answer: "End of Ramadan fasting"
},
{
  question: "Which of the following best explains the purpose of puberty rites?",
  options: [
    "Entertainment",
    "Preparation for adulthood",
    "Punishment",
    "Wealth creation"
  ],
  answer: "Preparation for adulthood"
},
{
  question: "Which of the following distinguishes religious rites from cultural rites?",
  options: [
    "No difference",
    "Religious rites are based on faith beliefs",
    "Cultural rites are always religious",
    "Religious rites have no meaning"
  ],
  answer: "Religious rites are based on faith beliefs"
},
{
  question: "Which of the following best explains the role of prophets?",
  options: [
    "Leading businesses",
    "Delivering messages from God",
    "Avoiding responsibility",
    "Controlling governments"
  ],
  answer: "Delivering messages from God"
},
{
  question: "Which of the following best explains why festivals are important?",
  options: [
    "They promote laziness",
    "They remind people of religious events and values",
    "They create conflict",
    "They reduce unity"
  ],
  answer: "They remind people of religious events and values"
},
{
  question: "A person performs religious duties but treats others unfairly. What is the main issue?",
  options: [
    "Strong faith",
    "Lack of moral application",
    "Discipline",
    "Obedience"
  ],
  answer: "Lack of moral application"
},
{
  question: "Which of the following best explains why religious knowledge must influence behaviour?",
  options: [
    "To gain recognition",
    "To ensure moral living",
    "To impress others",
    "To avoid punishment only"
  ],
  answer: "To ensure moral living"
},
{
  question: "A student studies religious teachings but does not practice them. What is lacking?",
  options: [
    "Knowledge",
    "Application",
    "Faith",
    "Understanding"
  ],
  answer: "Application"
},
{
  question: "Which of the following best explains practical religion?",
  options: [
    "Memorizing teachings",
    "Living according to religious principles",
    "Attending ceremonies only",
    "Reading scriptures only"
  ],
  answer: "Living according to religious principles"
},
{
  question: "A person claims to be fair but favors friends over others. What is lacking?",
  options: [
    "Justice",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Justice"
},
{
  question: "Which of the following best explains justice in society?",
  options: [
    "Treating people differently",
    "Ensuring fairness in all situations",
    "Ignoring others",
    "Avoiding decisions"
  ],
  answer: "Ensuring fairness in all situations"
},
{
  question: "A student refuses to admit wrongdoing and continues bad behaviour. What is lacking?",
  options: [
    "Repentance",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Repentance"
},
{
  question: "Which of the following best explains true repentance?",
  options: [
    "Admitting wrong without change",
    "Admitting wrong and making correction",
    "Ignoring mistakes",
    "Blaming others"
  ],
  answer: "Admitting wrong and making correction"
},
{
  question: "A person works hard but cheats others to gain advantage. What is lacking?",
  options: [
    "Honesty",
    "Discipline",
    "Faith",
    "Patience"
  ],
  answer: "Honesty"
},
{
  question: "Which of the following best explains why honesty is important in work?",
  options: [
    "It promotes deception",
    "It builds trust and fairness",
    "It reduces effort",
    "It encourages selfishness"
  ],
  answer: "It builds trust and fairness"
},
{
  question: "A student avoids responsibility and blames others. What is lacking?",
  options: [
    "Accountability",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Accountability"
},
{
  question: "Which of the following best explains accountability in daily life?",
  options: [
    "Avoiding responsibility",
    "Taking responsibility for actions",
    "Blaming others",
    "Ignoring consequences"
  ],
  answer: "Taking responsibility for actions"
},
{
  question: "A person refuses to respect others' beliefs. What is lacking?",
  options: [
    "Tolerance",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following best explains religious tolerance?",
  options: [
    "Rejecting other beliefs",
    "Respecting different beliefs peacefully",
    "Avoiding interaction",
    "Promoting one belief only"
  ],
  answer: "Respecting different beliefs peacefully"
},
{
  question: "A student is always quick to judge others without understanding them. What is lacking?",
  options: [
    "Empathy",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Empathy"
},
{
  question: "Which of the following best explains empathy in society?",
  options: [
    "Ignoring others� feelings",
    "Understanding others' perspectives",
    "Avoiding communication",
    "Judging quickly"
  ],
  answer: "Understanding others' perspectives"
},
{
  question: "A person seeks revenge instead of resolving issues peacefully. What is lacking?",
  options: [
    "Forgiveness",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains reconciliation?",
  options: [
    "Continuing conflict",
    "Restoring relationships after conflict",
    "Ignoring problems",
    "Seeking revenge"
  ],
  answer: "Restoring relationships after conflict"
},
{
  question: "A student fails due to poor planning and lack of focus. What is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why discipline is key to success?",
  options: [
    "It reduces effort",
    "It ensures consistent effort and focus",
    "It promotes laziness",
    "It creates confusion"
  ],
  answer: "It ensures consistent effort and focus"
},
{
  question: "A person attends religious services regularly but is dishonest in dealings. What is the main issue?",
  options: [
    "Strong faith",
    "Lack of application of teachings",
    "Discipline",
    "Obedience"
  ],
  answer: "Lack of application of teachings"
},
{
  question: "Which of the following best explains why religious teachings must be practiced daily?",
  options: [
    "To impress others",
    "To guide behaviour consistently",
    "To gain popularity",
    "To avoid punishment only"
  ],
  answer: "To guide behaviour consistently"
},
{
  question: "A student refuses to follow rules and ignores consequences. What is lacking?",
  options: [
    "Discipline",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why discipline is essential for success?",
  options: [
    "It limits freedom",
    "It ensures consistent effort",
    "It reduces responsibility",
    "It promotes laziness"
  ],
  answer: "It ensures consistent effort"
},
{
  question: "A person claims to be fair but always supports friends unfairly. What is lacking?",
  options: [
    "Justice",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Justice"
},
{
  question: "Which of the following best explains justice in decision-making?",
  options: [
    "Favoring certain people",
    "Making fair and unbiased decisions",
    "Ignoring others",
    "Avoiding responsibility"
  ],
  answer: "Making fair and unbiased decisions"
},
{
  question: "A student admits wrongdoing but refuses to change behaviour. What is lacking?",
  options: [
    "Repentance",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Repentance"
},
{
  question: "Which of the following best explains why repentance requires change?",
  options: [
    "To impress others",
    "To show true commitment to improvement",
    "To avoid punishment only",
    "To gain popularity"
  ],
  answer: "To show true commitment to improvement"
},
{
  question: "A person lies to gain advantage and later regrets it. What is the lesson?",
  options: [
    "Dishonesty leads to success",
    "Wrong actions have consequences",
    "Lying is acceptable",
    "Truth is not important"
  ],
  answer: "Wrong actions have consequences"
},
{
  question: "Which of the following best explains why truthfulness is important in relationships?",
  options: [
    "It creates confusion",
    "It builds trust and reliability",
    "It reduces communication",
    "It encourages dishonesty"
  ],
  answer: "It builds trust and reliability"
},
{
  question: "A student blames others for mistakes instead of accepting responsibility. What is lacking?",
  options: [
    "Accountability",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Accountability"
},
{
  question: "Which of the following best explains accountability?",
  options: [
    "Avoiding responsibility",
    "Accepting consequences of actions",
    "Blaming others",
    "Ignoring behaviour"
  ],
  answer: "Accepting consequences of actions"
},
{
  question: "A person refuses to accept others� beliefs and creates conflict. What is lacking?",
  options: [
    "Tolerance",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following best explains why tolerance promotes peace?",
  options: [
    "It encourages conflict",
    "It allows peaceful coexistence",
    "It reduces understanding",
    "It limits interaction"
  ],
  answer: "It allows peaceful coexistence"
},
{
  question: "A student reacts angrily without understanding the situation. What is lacking?",
  options: [
    "Empathy",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Empathy"
},
{
  question: "Which of the following best explains emotional maturity?",
  options: [
    "Reacting impulsively",
    "Controlling emotions and understanding others",
    "Avoiding people",
    "Ignoring feelings"
  ],
  answer: "Controlling emotions and understanding others"
},
{
  question: "A person refuses to forgive and holds grudges. What is the effect?",
  options: [
    "Peace",
    "Unity",
    "Bitterness",
    "Happiness"
  ],
  answer: "Bitterness"
},
{
  question: "Which of the following best explains why forgiveness is important?",
  options: [
    "It promotes revenge",
    "It restores relationships",
    "It creates conflict",
    "It reduces communication"
  ],
  answer: "It restores relationships"
},
{
  question: "A student fails due to poor planning and lack of discipline. What is the lesson?",
  options: [
    "Success comes easily",
    "Discipline is necessary for success",
    "Planning is not important",
    "Failure is unavoidable"
  ],
  answer: "Discipline is necessary for success"
},
{
  question: "Which of the following best explains why planning is important?",
  options: [
    "It delays progress",
    "It helps achieve goals effectively",
    "It reduces effort",
    "It creates confusion"
  ],
  answer: "It helps achieve goals effectively"
},
{
  question: "A person knows what is right but deliberately chooses to do wrong. What is lacking?",
  options: [
    "Knowledge",
    "Self-discipline",
    "Faith",
    "Understanding"
  ],
  answer: "Self-discipline"
},
{
  question: "Which of the following best explains why knowledge alone is not enough in religion?",
  options: [
    "Knowledge is unimportant",
    "Knowledge must be applied in behaviour",
    "Knowledge replaces action",
    "Knowledge is optional"
  ],
  answer: "Knowledge must be applied in behaviour"
},
{
  question: "A student refuses to change despite repeated correction. What is lacking?",
  options: [
    "Repentance",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Repentance"
},
{
  question: "Which of the following best explains true change of behaviour?",
  options: [
    "Temporary improvement",
    "Permanent positive transformation",
    "Ignoring mistakes",
    "Blaming others"
  ],
  answer: "Permanent positive transformation"
},
{
  question: "A person treats others well only when it benefits them. What is lacking?",
  options: [
    "Sincerity",
    "Kindness",
    "Faith",
    "Tolerance"
  ],
  answer: "Sincerity"
},
{
  question: "Which of the following best explains sincerity?",
  options: [
    "Acting for personal gain",
    "Doing good with genuine intentions",
    "Seeking recognition",
    "Avoiding responsibility"
  ],
  answer: "Doing good with genuine intentions"
},
{
  question: "A student always seeks revenge instead of resolving issues peacefully. What is lacking?",
  options: [
    "Forgiveness",
    "Faith",
    "Knowledge",
    "Discipline"
  ],
  answer: "Forgiveness"
},
{
  question: "Which of the following best explains peaceful conflict resolution?",
  options: [
    "Ignoring problems",
    "Resolving issues through dialogue",
    "Seeking revenge",
    "Avoiding communication"
  ],
  answer: "Resolving issues through dialogue"
},
{
  question: "A person refuses to accept responsibility for actions. What is lacking?",
  options: [
    "Accountability",
    "Faith",
    "Kindness",
    "Tolerance"
  ],
  answer: "Accountability"
},
{
  question: "Which of the following best explains responsibility?",
  options: [
    "Blaming others",
    "Accepting and performing duties",
    "Avoiding actions",
    "Ignoring consequences"
  ],
  answer: "Accepting and performing duties"
},
{
  question: "A student ignores the feelings of others and acts selfishly. What is lacking?",
  options: [
    "Empathy",
    "Faith",
    "Knowledge",
    "Strength"
  ],
  answer: "Empathy"
},
{
  question: "Which of the following best explains compassion?",
  options: [
    "Ignoring suffering",
    "Showing concern for others' suffering",
    "Avoiding interaction",
    "Judging others"
  ],
  answer: "Showing concern for others' suffering"
},
{
  question: "A person acts fairly only when supervised. What is lacking?",
  options: [
    "Integrity",
    "Faith",
    "Knowledge",
    "Tolerance"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains integrity in society?",
  options: [
    "Doing right only when seen",
    "Maintaining honesty and moral principles always",
    "Following others blindly",
    "Avoiding responsibility"
  ],
  answer: "Maintaining honesty and moral principles always"
},
{
  question: "A student wastes time and later regrets it. What is the lesson?",
  options: [
    "Time is unlimited",
    "Time should be used wisely",
    "Time is not important",
    "Time can be recovered easily"
  ],
  answer: "Time should be used wisely"
},
{
  question: "Which of the following best explains why time is valuable?",
  options: [
    "It can be replaced easily",
    "It is limited and must be used wisely",
    "It is not important",
    "It reduces effort"
  ],
  answer: "It is limited and must be used wisely"
},
{
  question: "A person spends money without planning and suffers later. What is the lesson?",
  options: [
    "Money is unlimited",
    "Financial discipline is important",
    "Spending freely is good",
    "Saving is unnecessary"
  ],
  answer: "Financial discipline is important"
},
{
  question: "Which of the following best explains wise use of resources?",
  options: [
    "Wasting resources",
    "Using resources carefully and responsibly",
    "Ignoring needs",
    "Avoiding planning"
  ],
  answer: "Using resources carefully and responsibly"
},
{
  question: "A student follows bad friends despite knowing the consequences. What is lacking?",
  options: [
    "Self-control",
    "Faith",
    "Knowledge",
    "Patience"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why self-control is important?",
  options: [
    "It limits freedom",
    "It helps avoid wrong actions",
    "It reduces responsibility",
    "It creates fear"
  ],
  answer: "It helps avoid wrong actions"
},

  {
    question: "A person who supports unity and cooperation is said to be:",
    options: ["Stubborn", "A peacemaker", "Aggressive", "Rude"],
    answer: "A peacemaker"
   }
];

export default jhsrmeQuestions;